// TSS vite/03 §"Query keys convention".
// Tuples, entity name first, scope narrowing rightward.

export const teamKeys = {
    all:     ['teams'],
    list:    (params) => ['teams', 'list', params],
    detail:  (id)     => ['teams', 'detail', id],
    // Members hang off the team so invalidating a team's membership does not
    // throw away the list of teams.
    members: (id)     => ['teams', 'detail', id, 'members'],
};
